import bannerAsset from "@/assets/financing/ideal4finance-partner-banner.png.asset.json";

const bannerSrc = bannerAsset.url;
import { cn } from "@/lib/utils";

const BANNER_ALT =
  "We've partnered with Ideal4Finance to bring you flexible finance options";

type Ideal4FinancePartnerBannerProps = {
  className?: string;
};

export function Ideal4FinancePartnerBanner({ className }: Ideal4FinancePartnerBannerProps) {
  return (
    <div className={cn("w-full", className)}>
      <img
        src={bannerSrc}
        alt={BANNER_ALT}
        width={1080}
        height={270}
        loading="lazy"
        decoding="async"
        className="w-full h-auto rounded-xl"
      />
    </div>
  );
}
